var _g, _g2, _g3, _g4, _g5, _path, _path2, _g6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeMatchingImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 106,
    viewBox: "0 0 164 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7065,
    y: 19.9678,
    width: 64.5534,
    height: 20.9036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3065,
    y: 20.6902,
    width: 63.0085,
    height: 19.5588,
    rx: 1.96934,
    stroke: "black",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8909,
    y: 24.542,
    width: 11.0246,
    height: 11.0246,
    rx: 5.51228,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5752,
    y: 26.3057,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5752,
    y: 26.3057,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5752,
    y: 26.3057,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5752,
    y: 26.3057,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5754,
    y: 31.624,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5754,
    y: 31.624,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5754,
    y: 31.624,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.5754,
    y: 31.624,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#E3DFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7065,
    y: 46.4566,
    width: 64.5534,
    height: 20.9036,
    rx: 1.96934,
    stroke: "#35363A",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3065,
    y: 46.5566,
    width: 63.5534,
    height: 20.1036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8909,
    y: 51.1309,
    width: 9.72756,
    height: 10.3761,
    rx: 4.86378,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 52.667,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 52.667,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 52.667,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 52.667,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 57.8887,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 57.8887,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 57.8887,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.2778,
    y: 57.8887,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.7065,
    y: 73.793,
    width: 64.5534,
    height: 20.9036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3065,
    y: 74.5654,
    width: 63.0085,
    height: 20.9036,
    rx: 1.96934,
    stroke: "#35363A",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8909,
    y: 78.3672,
    width: 10.3761,
    height: 10.3761,
    rx: 5.18803,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 79.9033,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 79.9033,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 79.9033,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 79.9033,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 85.125,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 85.125,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 85.125,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9265,
    y: 85.125,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.9573,
    y: 19.9678,
    width: 63.5534,
    height: 20.9036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2297,
    y: 20.6902,
    width: 63.0085,
    height: 19.5588,
    rx: 1.96934,
    stroke: "#35363A",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.142,
    y: 24.542,
    width: 11.0246,
    height: 11.6731,
    rx: 5.51228,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 26.7266,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 26.7266,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 26.7266,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 26.7266,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 31.9482,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 31.9482,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 31.9482,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 31.9482,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.9573,
    y: 46.5566,
    width: 63.5534,
    height: 20.1036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2297,
    y: 46.4566,
    width: 63.0085,
    height: 20.9036,
    rx: 1.96934,
    stroke: "black",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.142,
    y: 51.1309,
    width: 11.0246,
    height: 11.0246,
    rx: 5.51228,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 52.8945,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 52.8945,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 52.8945,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 52.8945,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 58.2129,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 58.2129,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 58.2129,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 58.2129,
    width: 38.6846,
    height: 2.17941,
    rx: 1.08971,
    fill: "#E3DFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1851 29.5945C77.9503 29.5945 77.7601 29.7848 77.7601 30.0195C77.7601 30.2543 77.9503 30.4445 78.1851 30.4445V29.5945ZM95.3329 56.9089C95.4989 56.7429 95.4989 56.4739 95.3329 56.3079L92.6282 53.6032C92.4623 53.4372 92.1932 53.4372 92.0272 53.6032C91.8612 53.7692 91.8612 54.0383 92.0272 54.2042L94.4314 56.6084L92.0272 59.0126C91.8612 59.1785 91.8612 59.4476 92.0272 59.6136C92.1932 59.7796 92.4623 59.7796 92.6282 59.6136L95.3329 56.9089ZM86.1837 38.4432V48.1847H87.0337V38.4432H86.1837ZM86.1837 48.1847C86.1837 53.0717 90.1454 57.0334 95.0324 57.0334V56.1834C90.6149 56.1834 87.0337 52.6023 87.0337 48.1847H86.1837ZM78.1851 30.4445C82.6026 30.4445 86.1837 34.0257 86.1837 38.4432H87.0337C87.0337 33.5562 83.072 29.5945 78.1851 29.5945V30.4445Z",
    fill: "#35363A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1851 29.5945C77.9503 29.5945 77.7601 29.7848 77.7601 30.0195C77.7601 30.2543 77.9503 30.4445 78.1851 30.4445V29.5945ZM95.3329 56.9089C95.4989 56.7429 95.4989 56.4739 95.3329 56.3079L92.6282 53.6032C92.4623 53.4372 92.1932 53.4372 92.0272 53.6032C91.8612 53.7692 91.8612 54.0383 92.0272 54.2042L94.4314 56.6084L92.0272 59.0126C91.8612 59.1785 91.8612 59.4476 92.0272 59.6136C92.1932 59.7796 92.4623 59.7796 92.6282 59.6136L95.3329 56.9089ZM86.1837 38.4432V48.1847H87.0337V38.4432H86.1837ZM86.1837 48.1847C86.1837 53.0717 90.1454 57.0334 95.0324 57.0334V56.1834C90.6149 56.1834 87.0337 52.6023 87.0337 48.1847H86.1837ZM78.1851 30.4445C82.6026 30.4445 86.1837 34.0257 86.1837 38.4432H87.0337C87.0337 33.5562 83.072 29.5945 78.1851 29.5945V30.4445Z",
    fill: "#35363A"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.9573,
    y: 73.793,
    width: 63.5534,
    height: 20.9036,
    rx: 2.24176,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2297,
    y: 74.5654,
    width: 63.0085,
    height: 20.9036,
    rx: 1.96934,
    stroke: "#35363A",
    strokeWidth: 0.544853,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.142,
    y: 78.3672,
    width: 11.0246,
    height: 11.0246,
    rx: 5.51228,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 80.2275,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 80.2275,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 80.2275,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 80.2275,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 85.4492,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 85.4492,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 85.4492,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.826,
    y: 85.4492,
    width: 37.4961,
    height: 2.08312,
    rx: 1.04156,
    fill: "#9BBAC1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6641 91.6472L85.9932 88.5449",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7294 1.21081C43.1328 1.35734 44.1532 2.61575 44.0067 4.01915C43.8602 5.42254 42.6018 6.44302 41.1984 6.29649C39.795 6.14996 38.7745 4.89155 38.921 3.48815C39.0676 2.08476 40.326 1.06428 41.7294 1.21081Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57084 40.5762C3.21547 40.5762 3.73885 41.0996 3.73885 41.7442C3.73885 42.3888 3.21547 42.9122 2.57084 42.9122C1.92622 42.9122 1.40283 42.3888 1.40283 41.7442C1.40283 41.0996 1.92622 40.5762 2.57084 40.5762Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3137 99.5781L13.4827 95.0381",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7039 96.7529L15.2439 97.9219",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.977 97.118C145.38 97.2646 146.401 98.523 146.254 99.9264C146.108 101.33 144.849 102.35 143.446 102.204C142.043 102.057 141.022 100.799 141.169 99.3954C141.315 97.992 142.574 96.9715 143.977 97.118Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.464 9.15527L150.378 4.55717",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M147.7 6.42383L152.298 7.3382",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0449 66.1019C92.8983 66.191 93.5189 66.9562 93.4298 67.8097C93.3406 68.6631 92.5754 69.2837 91.722 69.1945C90.8685 69.1054 90.248 68.3402 90.3371 67.4868C90.4262 66.6333 91.1914 66.0128 92.0449 66.1019Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.770189
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5527 26.6924L92.8861 22.1979",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0466 23.8096L94.5412 25.143",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1871 103.193C65.8317 103.193 66.3551 103.717 66.3551 104.361C66.3551 105.006 65.8317 105.529 65.1871 105.529C64.5424 105.529 64.019 105.006 64.019 104.361C64.019 103.717 64.5424 103.193 65.1871 103.193Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeMatchingImg);
export default __webpack_public_path__ + "static/media/question_type_matching_img.8fba409faf2f0d00d493642ec5a0832f.svg";
export { ForwardRef as ReactComponent };